var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-logo"}},[(_vm.isMobile)?_c('img',{attrs:{"src":require("@/assets/header-logo-icon.png"),"alt":"美团骑行合作商平台"}}):_c('img',{attrs:{"src":require("@/assets/header-logo.png"),"alt":"美团骑行合作商平台"}})])}
var staticRenderFns = []

export { render, staticRenderFns }